// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"G_thecomp__o20Cf"};